export default "__VITE_ASSET__3b21314c__"